<template>
  <section class="stab-view" v-if="stablishment">
    <!-- Header -->
    <div class="stab-view-header">
      <div class="stab-view-header-left">
        <button class="stab-back-btn" @click="onStablishmentListBack">
          <i class="el-icon-arrow-left"></i>
        </button>
        <div>
          <h4 class="stab-view-title">{{ stablishment.name }}</h4>
          <span class="stab-view-code">Código: {{ stablishment.code }}</span>
        </div>
      </div>
      <ButtonDeleteComponent
        :isShowButton="false"
        @onConfirmDelete="onConfirmDeleteStablishment"
      />
    </div>

    <!-- Info grid -->
    <div class="stab-info-grid">
      <div class="stab-info-item stab-info-full">
        <label><i class="el-icon-office-building"></i> Nombre comercial</label>
        <p>{{ stablishment.name }}</p>
      </div>
      <div class="stab-info-item">
        <label><i class="el-icon-location-outline"></i> Ciudad</label>
        <p>{{ getEstablishmentCity || "-" }}</p>
      </div>
      <div class="stab-info-item">
        <label><i class="el-icon-map-location"></i> Dirección</label>
        <p>{{ stablishment.address || "-" }}</p>
      </div>
      <div class="stab-info-item">
        <label><i class="el-icon-message"></i> Correo</label>
        <p>{{ stablishment.email || "-" }}</p>
      </div>
      <div class="stab-info-item">
        <label><i class="el-icon-phone-outline"></i> Teléfono</label>
        <p>{{ stablishment.phone || "-" }}</p>
      </div>
      <div class="stab-info-item stab-info-full">
        <label><i class="el-icon-link"></i> Sitio web</label>
        <p>{{ stablishment.website || "-" }}</p>
      </div>
    </div>

    <!-- Puntos de emisión -->
    <div class="stab-emission-section">
      <h5 class="stab-section-title">
        <i class="el-icon-printer"></i> Puntos de emisión
      </h5>
      <BusinessEmissionPointListComponent
        :setEmissionPoints="stablishment.emision_points"
        :establishmentId="stablishment.id"
        @getStablishments="onStablishmentListBack"
      />
    </div>
  </section>
</template>

<script>
import BusinessEmissionPointListComponent from "./EmissionPointList";
import ButtonDeleteComponent from "../../../../components/ButtonDelete";
import tradeService from "../../../services/tradeService";

export default {
  name: "BusinessStablishmentViewComponent",
  data() {
    return {};
  },
  computed: {
    getEstablishmentCity() {
      const { city } = this.stablishment;
      return city && city.name;
    }
  },
  methods: {
    onStablishmentListBack() {
      this.$emit("onStablishmentListBack");
    },
    async onConfirmDeleteStablishment() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await tradeService
          .deleteStablishmentId(this.stablishment)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message } = response.data;
        if (success) {
          this.onStablishmentListBack();
          this.$notifications.success({ message });
        }
      } catch (error) {
        return false;
      }
    }
  },
  components: {
    BusinessEmissionPointListComponent,
    ButtonDeleteComponent
  },
  props: {
    stablishment: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3fdbbf;
$border: #e4eaf6;
$bg: #f7f8f9;

.stab-view-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.stab-view-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.stab-back-btn {
  width: 36px;
  height: 36px;
  border: 1px solid $border;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: $primary;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    background: $bg;
    border-color: $primary;
  }
}
.stab-view-title {
  font-size: 18px;
  font-weight: 700;
  color: $primary;
  margin: 0;
}
.stab-view-code {
  font-size: 13px;
  color: #909399;
}

.stab-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 24px;
}
.stab-info-item {
  padding: 16px 20px;
  border-bottom: 1px solid $border;
  border-right: 1px solid $border;

  &:nth-child(even) {
    border-right: none;
  }

  &:nth-last-child(-n + 2) {
    border-bottom: none;
  }

  label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #909399;
    margin-bottom: 4px;

    i {
      font-size: 13px;
    }
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: $primary;
    margin: 0;
  }
}
.stab-info-full {
  grid-column: 1 / -1;
  border-right: none !important;
}

.stab-emission-section {
  margin-top: 8px;
}
.stab-section-title {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
  margin: 0 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: $accent;
  }
}

@media (max-width: 768px) {
  .stab-info-grid {
    grid-template-columns: 1fr;
  }

  .stab-info-item {
    border-right: none !important;
  }
}
</style>
